<div style="position: relative;">
  <div class="p-5 bg-indigo-900 py-12 m-0" style="background-color: #111041">
    <div class="font-bold text-white-50 content-center">
      <ul class="flex flex-row space-x-6 py-4 justify-center">
        <li (click)="onAboutUs()">
          <a class="hover:underline cursor-pointer">About Us</a>
        </li>
        <li (click)="onContact()">
          <a class="hover:underline cursor-pointer">Terms and Conditions</a>
        </li>
        <li (click)="onPrivacy()">
          <a class="hover:underline cursor-pointer">Privacy Policy</a>
        </li>
        <li (click)="onHome()">
          <a class="hover:underline cursor-pointer">Home</a>
        </li>
        <button id="toggleCookies" class="fixed bottom-0 right-0  bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded text-sm	">Cookies</button>
      </ul>
    </div>
    <div class="">
      <div style="text-align: center">
        <p class="text-gray-600 text-xs">
          © 2021&nbsp;Moving Picture Club. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</div>
